"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  ImageManipulator: () => ImageManipulator
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneImageManipulator");
  return hybrid;
}
function transform(uri) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options_format;
  if (options.flip != null && options.flip !== "horizontal" && options.flip !== "vertical") throw new Error("ImageManipulator.transform: flip must be 'horizontal' or 'vertical'");
  return native().transform(uri, {
    ...options,
    format: (_options_format = options.format) !== null && _options_format !== void 0 ? _options_format : "jpeg"
  }).catch(import_nativeError.rethrowNativeError);
}
var ImageManipulator = Object.freeze({
  transform
});
//# sourceMappingURL=index.native.js.map
